import { render, staticRenderFns } from "./choseAppointment.vue?vue&type=template&id=9c6703c8&scoped=true&"
import script from "./choseAppointment.vue?vue&type=script&lang=js&"
export * from "./choseAppointment.vue?vue&type=script&lang=js&"
import style0 from "./choseAppointment.vue?vue&type=style&index=0&id=9c6703c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c6703c8",
  null
  
)

export default component.exports